module.exports = {
    "index_title": "Spice up your photos! 🌶️",
    "index_title_promo": "Spice up your photos!",
    "index_subtitle": "This AI got totally naughty.<br />Turn a usual photo into a playful one and see how much hotter you can get.<br />Wanna play?",
    "index_subtitle_promo": "AI got totally naughty and generates pics that are too hot for {{app}}.<br />So welcome a new app!&nbsp;🌶<br />Wanna play? 😉",
    "index_d22_block_title": "Santa’s Hotshot Gifts",
    "index_d22_block_text": "Naughty or nice, unwrap this season’s surprise!",
    "index_d22_block_button": "Hotify now",

    "get_the_app": "Get the app",
    "get_free_app": "Get free app",
    "upload_choose_photo_button": "Choose photo",
    "refresh_button": "Refresh",

    "result_title": "Results",
    "result_notice_1": "You look amazing! <span class=\"text-decoration\">Share to inspire others</span>",
    "result_notice_2": "Time to show off your makeover! <span class=\"text-decoration\">Tap to share</span>",
    "result_notice_3": "Stunning looks are for sharing. <span class=\"text-decoration\">Tap if you agree</span>",
    "result_notice_4": "Don’t keep your look to yourself, <span class=\"text-decoration\">share it now!</span>",

    "try_another_photo": "Try another photo",
    "retry": "Retry",
    "next": "next",

    "photochooser_title": "Upload your photos",
    "photochooser_photos_count": "Uploaded: <span>{{num}} photos</span>",
    "photochooser_photos_error": "(Some photos cannot be used. Tap to learn more)",
    "photochooser_delete_photo": "Select a photo to delete",
    "photochooser_rule_1": "<span>At least 1 photos</span>",
    "photochooser_rule_2": "All the photos are of <span>the same person</span>",
    "photochooser_rule_3": "<span>Only one person</span> in a photo",

    "button__select_photos": "select photos",
    "button__select_more": "select more",
    "button__add_more": "Add more",
    "button__proceed": "proceed",
    "button__select_to_delete": "Select a photo to delete",
    "button__tap_to_delete": "Tap a photo to delete",
    "button__cancel": "cancel",
    "button__retry": "retry",
    "button__try_again": "try again",
    "button__delete": "delete",
    "button__ok": "OK",

    "download": "Download",
    "more": "Hotify more",
    "change": "Change photo",
    "continue": "Continue",
    "subscribe": "Subscribe",
    //"save_and_share": "Save & Share",

    "error__default_message": "Something went wrong",
    "error_title": "Sorry, couldn’t load content.",
    "error__api_code_1": "Internal error",
    "error__api_code_2": "Incorrect params",
    "error__api_code_3": "Processing failure",
    "error__api_code_401": "Unauthorized request",
    "error__api_code_404": "Not found",
    "error__api_code_410": "The requested content is deleted",
    "error__api_code_415": "Sorry, this file format is not supported. Please upload an image file (JPEG or PNG).",

    "error_overload": "We are terribly sorry, but our servers experience too much of a load currently due to skyrocketing app downloads. Please, come back a little later. We are working hard to fix everything ASAP.",
    "error_processing_timeout": "Timeout was reached, please try again",

    "watermark_screen__title": "",
    "draggable_watermark_tooltip": "<span>Tap&Drag</span> to move <br>& delete watermark",
    "watermark_removal_modal__title": "Yep, you can remove the watermark, but…",
    "watermark_removal_modal__text1": "We’d like you to keep it and let your friends know about our app. Don’t feel like keeping it? Spread the hash-word about {{app_name}}.",
    "watermark_removal_modal__text2": "The entire amount of money raised goes to a charity fund!",
    "watermark_removal_modal__notice": "<span class=\"text-bold\">TIP:</span> you can just drag the watermark to the position you want.",
    "watermark_removal_modal__choice": "Your choice?",
    "watermark_removal_modal__confirm": "Remove watermark",
    "watermark_removal_modal__cancel": "Spread the good!",
    "watermark_removal_modal__close": "Close",

    "processing_text_1": "Nice to naughty transformation is happening 😈",
    "processing_text_2": "Spicing up the photo… 🌶️",
    "processing_text_3": "Getting the most playful looks! 👯🏼‍♀️",
    "processing_text_4": "It’s getting blazing hot in here! 🔥🔥",
    "processing_footer_text": "Who’s in your photo?",
    "processing_female_button": "Female",
    "processing_male_button": "Male",
    "processing_human_button": "Other",
    "processing_glamour_button": "Glamour",
    "processing_realistic_button": "Realistic",
    "processing_creative": "The world around is ever changing and your online image should too!",

    "subscribe_subscription_terms": "Renews automatically. Cancel any time.&nbsp;<span>Terms</span>",

    "cancel": "cancel",

    "subscribe_banner__text_1": "It was just a warm up.",
    "subscribe_banner__text_2": "Even spicier looks come with a premium plan.",
    "subscribe_banner__text_3": "Ads will be gone as well.",
    "subscribe_banner__subtext": "Enjoy 3 days for FREE, then {{price}}/week",

    "purchase_banner__text": "<span class=\"text-bold\">Get 100+ <span class=\"text-yellow\">premium</span> artworks</span>",
    "purchase_banner__subtext": "Enjoy more variations with {{price}} one-time purchase",

    "share_modal__title": "Saved to gallery!",
    "share_modal__text_1": "You look amazing! Share it.",
    "share_modal__text_2": "<span>We love you!</span> Love us back by adding hashtag to your post",
    "share_modal__copy": "Copy",
    "share_modal__copied": "Copied",
    "share_modal__create_animation": "Create animation",
    "share_modal__creating_animation": "Creating animation",
    "share_modal__creating_animation_dots": "Creating animation...",
    "share_modal__watch_video": "Watch the video",
    "share_modal__create_collage": "Create collage",
    "share_modal__creating_collage": "Creating collage",
    "share_modal__creating_collage_dots": "Creating collage...",
    "share_modal__watch_collage": "Watch the collage",

    "rewarded_ad_banner__text": "<span class=\"text-bold text-yellow\">Keep looking</span>",
    "rewarded_ad_banner__subtext": "Unlock other results by watching a short sponsored video.",

    "portrait_modal__title": "Can AI see more of your body?👯‍♀️",
    "portrait_modal__text": "Half- or full-body photos make best results, so we would highly recommend choosing another photo.",
    "portrait_modal_bad_text_modal": "<span>Bad:</span><br> no body",
    "portrait_modal_good_text_modal": "<span>Good:</span><br> full-body",
    "portrait_modal__continue": "Proceed anyway",
    "portrait_modal__choose_photo": "Change photo",

    "persons_modal_1__title": "Two people?",
    "persons_modal_1__text": "It looks like there are two people in this photo. We can switch you to the “For two” mode or please choose a one-person photo.",
    "persons_modal_1__bad_text_modal": "<span>Wrong:</span> several people",
    "persons_modal_1__good_text_modal": "<span>Right:</span> one person",
    "persons_modal__choose_photo": "Change photo",
    "persons_modal__continue": "Switch me",

    "persons_modal_2__title": "One-person photo?",
    "persons_modal_2__text": "This mode supports photos with two people only. We can switch you to the single mode or please choose a two-people photo.",
    "persons_modal_2__bad_text_modal": "<span>Wrong:</span> one person",
    "persons_modal_2__good_text_modal": "<span>Right:</span> two people",

    "photo_guide_title": "Choose the right photo",
    "photo_guide_text": "Half- or full-body photos make best results, so we would highly recommend choosing another photo.",
    "photo_guide_notice": "There can be <span>two people</span> in a photo.",
    "photo_guide_notice_label": "<span>Hot tip!</span> 🔥",
    "got_it": "Got it",

    "age_limit_modal__18_title": "Hotify is available only 18+",
    "age_limit_modal__18_one_person_text": "Do you confirm that the age of the person on the photo is 18+?",
    "age_limit_modal__18_several_persons_text": "Do you confirm that the age of all people on the photo is 18+?",
    "age_limit_modal__13_text": "This photo contains people under 18 and we cannot process it on Hotify, please choose another photo.",
    "age_limit_modal__confirm": "Confirm",
    "age_limit_modal__choose_photo": "Choose another photo",

    "bad_upload_photo_title_modal": "Make sure there is body in your photos",
    "bad_upload_photo_text_modal": "We cannot hotify the body if it isn’t in a photo. Please choose a half-/full-body photo or subscribe to proceed without limits.",
    "bad_upload_photo_bad_text_modal": "<span>Wrong:</span><br> no body",
    "bad_upload_photo_good_text_modal": "<span>Right:</span><br> half/full-body",

    "bodysize_slim": "Slim",
    "bodysize_curve": "Curve",
    "bodysize_bigger": "Bigger",

    "original_context": "Original context",
    "original_context_tooltip": "Select this checkbox to preserve the original context of your photo.",

    "survey_title": "What is your 🔥 goal?",
    "survey_answer_hotlook": "Hot fantasy looks worth sharing ❤️‍🔥",
    "survey_answer_undress": "Undressing someone 🤭",

    "notification_title": "Your hot transition is ready!🔥",
    "notification_text": "It’s even cooler that we thought - <span>see for yourself.</span>",

    "instagram_modal__title": "Hot friendship is rare! 👯‍♀",
    "instagram_modal__text": "Type in your Instagram name so we could like your posts.",
    "instagram_modal__done": "Done",

    "one_person_photo_warning": "This effect works with one-person portraits only. Make sure there are no other people in a photo.",
    "two_person_photo_warning": "This effect works with two-person portraits only. Make sure there are two people in a photo.",

    "hair_color_modal__title": "Select hair color",
    "hair_color_style_modal__title": "Choose hair style & color you like best",
    "hair_color_style_modal__proceed_button": "Proceed",
    "hair_color_style_modal__skip_button": "Skip",
    "hair_color_style_modal__error_style": "Please select a hair style",
    "hair_color_style_modal__error_color": "Please select a hair color",

    "rules_modal__title": "Rules",
    "rules_modal__accept": "Accept",
    "rules_modal__text": "By clicking on Accept you automatically agree to the above terms.",
    "rules_modal__list_text_1": "You must be 18+ to use this website.",
    "rules_modal__list_text_2": "You can’t use others photo without their permission and persons under 18 years of age.",
    "rules_modal__list_text_3": "You are solely responsible for the images you generate.",

    "hotify__title": "Hotify",

    "preview_web_block__title": "Have someone to undress?",
    "preview_web_block__button": "Upload Photo to <span>undress</span>",
    "preview_web_block__text": "Files supported .jpg .png .heic<br> By using our services, you accept our <a href='https://pho.to/terms' target='_blank'>Terms of Service</a>",
};

